import React, { useState, useEffect, useRef } from 'react';
import authService from '../../api-authorization/AuthorizeService'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { nanoid } from '@reduxjs/toolkit'
import { eventUpdated } from './eventsSlice'
import { eventCloned } from './eventsSlice'
import { eventAdded } from './eventsSlice'
import { selectEventById } from './eventsSlice'
import "bootstrap/dist/css/bootstrap.min.css";

import { Stack, TextField, Paper, Grid, Checkbox, FormGroup, InputAdornment, OutlinedInput, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Card, CardContent, CardActions, Button, ButtonGroup, Box, FormControl, FormLabel, FormControlLabel, RadioGroup, Radio, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import axios from 'axios'
import TimezoneSelect from 'react-timezone-select'
import ReactDOM from 'react-dom'
import { updateEvent } from './eventsSlice'
import { cloneEvent } from './eventsSlice'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';


export default function CloneEvent({ match }) {
    const [authenticated, setAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isOrganizer, setIsOrganizer] = useState(false);
    const [isPlayer, setIsPlayer] = useState(false);
    const [userName, setUserName] = useState();
    const [idType, setIdType] = useState();
    const [playerId, setPlayerId] = useState();
    const [userRole, setUserRole] = useState("");

    const [copyEventDelegations, setCopyEventDelegations] = useState(false);
    const [copyDicsountPolicies, setCopyDicsountPolicies] = useState(true);

    //const { eventId } = match.params
    const [eventId, setEventId] = useState(match.params.eventId);
    const [eventStatus, setEventStatus] = useState(0);
    const [organizerID, setOrganizerID] = useState('');
    const [creatorID, setCreatorID] = useState('');
    const [event, setEvent] = useState(null);
    const [eventName, setEventName] = useState('');
    const [fromEventName, setFromEventName] = useState('');
    const [eventType, setEventType] = useState('TNM');
    const [eventFormat, setEventFormat] = useState('INP');
    const [eventPlatform, setEventPlatform] = useState('OTB');
    const [eventEntry, setEventEntry] = useState('OPN');
    const [eventUscfRated, setEventUscfRated] = useState(true);
    const [eventUscfOnlineRated, setEventUscfOnlineRated] = useState(false);
    const [eventFideRated, setEventFideRated] = useState(false);
    const [eventNormPossible, setEventNormPossible] = useState(false);
    const [eventPlatformRated, setEventPlatformRated] = useState(false);
    const [eventPairingSystem, seteventPairingSystem] = useState('SWS');
    const [eventTimeControl, setEventTimeControl] = useState('CLA');
    const [eventSeats, setEventSeats] = useState(1);
    const [eventRounds, setEventRounds] = useState(1);
    const [eventPrizeFund, setEventPrizeFund] = useState(0);
    const [eventServiceLevel, setEventServiceLevel] = useState(1);
    const [eventDescription, setEventDescription] = useState('');
    const [eventDescriptionJSON, setEventDescriptionJSON] = useState('');
    const [eventAddress, setEventAddress] = useState('');
    const [eventCity, setEventCity] = useState('');
    const [eventState, setEventState] = useState('WA');
    const [eventZipCode, setEventZipCode] = useState('');
    const [eventTimeZone, setEventTimeZone] = useState("Pacific Standard Time");
    const [eventStartDateTime, setEventStartDateTime] = useState(((new Date())));
    const [fromEventStartDateTime, setFromEventStartDateTime] = useState(((new Date())));
    const [eventEndDateTime, setEventEndDateTime] = useState(((new Date())));
    const [eventRegistrationDeadline, setEventRegistrationDeadline] = useState(((new Date())));
    const [eventByeRequestDeadline, setEventByeRequestDeadline] = useState(((new Date())));

    const [eventFlyerUrl, setEventFlyerUrl] = useState('');
    const [eventRegistrationUrl, setEventRegistrationUrl] = useState('');
    const [eventPairingUrl, setEventPairingUrl] = useState('');
    const [eventLiveGameUrl, setEventLiveGameUrl] = useState('');
    const [eventHotelReservationLink, setEventHotelReservationLink] = useState('');
    const [eventFideRegistrationLink, setEventFideRegistrationLink] = useState('');
    const eventStatusText = ['Draft', 'Published', 'Active', 'Locked', 'Registration Closed', 'Ongoing', 'Completed', 'Archived', 'Deleted'];

    const platforms = {
        OTB: 'Over The Board',
        CHE: 'Chess.com',
        LIC: 'Lichess.org',
        C24: 'Chess24.com',
        TON: 'Tornelo',
        ZOM: 'Zoom',
        OTH: 'Other'
    };

    const [editorState, setEditorState] = useState(
        () => EditorState.createEmpty(),
    );

    useEffect(() => {
        async function fetchData() {

            setAuthenticated(await authService.isAuthenticated());
            var user = await authService.getUser();
            if (user != null) {
                var role = user.role;
                setUserName(user.sub);
                if (user.sub.includes("FIDE")) {
                    setIsPlayer(true);
                    setIdType("FIDE");
                    setPlayerId(user.sub.replace("FIDE", ""));
                } else if (user.sub.includes("Affiliate")) {
                    setIsPlayer(false);
                    setIsOrganizer(true);
                }
                else if (user.sub.includes("USCF")) {
                    setIsPlayer(true);
                    setIdType("USCF");
                    setPlayerId(user.sub.replace("USCF", ""));
                }

                setUserRole(role);
                if (role.includes("Administrators"))
                    setIsAdmin(true);
            }

            const res = await axios.get('/api/Events/' + eventId);
            const eventData = res.data;
            setEventStatus(eventData.eventStatus)
            setOrganizerID(eventData.organizerID)
            setCreatorID(eventData.creatorID)
            setFromEventName(eventData.eventName)
            setEventName(eventData.eventName+" - Copy")
            setEventType(eventData.eventType)
            setEventFormat(eventData.eventFormat)
            setEventPlatform(eventData.eventPlatform)
            setEventEntry(eventData.eventEntry)
            setEventUscfRated(eventData.eventUscfRated)
            setEventUscfOnlineRated(eventData.eventUscfOnlineRated)
            setEventFideRated(eventData.eventFideRated)
            setEventNormPossible(eventData.eventNormPossible)
            setEventPlatformRated(eventData.eventPlatformRated)
            seteventPairingSystem(eventData.eventPairingSystem)
            setEventTimeControl(eventData.eventTimeControl)
            setEventSeats(eventData.eventSeats)
            setEventRounds(eventData.eventRounds)
            setEventPrizeFund(eventData.eventPrizeFund)
            setEventServiceLevel(eventData.eventServiceLevel)
            setEventDescription(eventData.eventDescription)
            setEventDescriptionJSON(eventData.eventDescriptionJSON)
            setEventAddress(eventData.eventAddress)
            setEventCity(eventData.eventCity)
            setEventState(eventData.eventState)
            setEventZipCode(eventData.eventZipCode)
            setEventTimeZone(eventData.eventTimeZone)
            setEventStartDateTime(eventData.eventStartDateTime);
            setFromEventStartDateTime(eventData.eventStartDateTime);
            setEventEndDateTime(eventData.eventEndDateTime);
            setEventRegistrationDeadline(eventData.eventRegistrationDeadline);
            setEventByeRequestDeadline(eventData.eventByeRequestDeadline);
            setEventFlyerUrl(eventData.eventFlyerUrl);
            setEventRegistrationUrl(eventData.eventRegistrationUrl);
            setEventPairingUrl(eventData.eventPairingUrl);
            setEventLiveGameUrl(eventData.eventLiveGameUrl);
            setEventHotelReservationLink(eventData.eventHotelReservationLink);
            setEventFideRegistrationLink(eventData.eventFideRegistrationLink);
            setEvent(eventData);

            if (eventData.eventDescriptionJSON) {
                setEditorState(() => EditorState.createWithContent(convertFromRaw(JSON.parse(eventData.eventDescriptionJSON))));
            }
        };
        fetchData();

        
    }, [eventId]);

    useEffect(() => {
        let content = editorState.getCurrentContent();
        let rawContent = convertToRaw(content);
        let jsonString = JSON.stringify(rawContent)
        setEventDescriptionJSON(jsonString);
        console.log(eventDescriptionJSON);
    }, [editorState]);

    const [cloneRequestStatus, setCloneRequestStatus] = useState('idle')

    const dispatch = useDispatch()
    const history = useHistory()

    const [openEventFideRatedAlert, setOpenEventFideRatedAlert] = React.useState(false);

    const canClone =
        (eventName !== fromEventName || eventStartDateTime !== fromEventStartDateTime) && cloneRequestStatus === 'idle'



    const handleCloseFideEventAlert = () => {
        setOpenEventFideRatedAlert(false);
    };


    const handleEventFormatChange = (event: SelectChangeEvent) => {
        setEventFormat(event.target.value);
    };

    const handleEventPlatformChange = (event: SelectChangeEvent) => {
        setEventPlatform(event.target.value);
        if (event.target.value === 'OTB' || event.target.value === 'ZOM' && event.target.value === 'OTH') {
            setEventPlatformRated(false);
        }
        if (event.target.value === 'OTB') {
            setEventUscfOnlineRated(false);
        }
    };

    const handleEventTypeChange = (event: SelectChangeEvent) => {
        setEventType(event.target.value);
    };

    const handleEventServiceLevelChange = (event: SelectChangeEvent) => {
        setEventServiceLevel(event.target.value);
    };
    

    const handleEventStatusChange = (event: SelectChangeEvent) => {
        setEventStatus(event.target.value);
    };
    

    const handleEventEntryChange = (event: SelectChangeEvent) => {
        setEventEntry(event.target.value);
    };

    const handleEventeventPairingSystemChange = (event: SelectChangeEvent) => {
        seteventPairingSystem(event.target.value);
    };

    const handleEventTimeControlChange = (event: SelectChangeEvent) => {
        setEventTimeControl(event.target.value);
    };

    //const handleServiceLevelChange = (event: SelectChangeEvent) => {
    //    setServiceLevel(event.target.value);
    //};

    const handleEventStateChange = (event: SelectChangeEvent) => {
        setEventState(event.target.value);
    };




    const handleEventTimeZoneChange = (event: SelectChangeEvent) => {
        setEventTimeZone(event.target.value);
    };


    const onCloneEventClicked = async () => {
        var clonedEventId = '';
        if (canClone) {
            try {
                setCloneRequestStatus('pending')
                //convert event descripton rich text into JSON
                //let content = editorState.getCurrentContent();
                //let jsonString = convertToRaw(content);
                //setEventDescriptionJSON(jsonString);
                var clonedEvent = await dispatch(cloneEvent({
                    eventId,
                    eventStatus,
                    organizerID,
                    creatorID,
                    eventName,
                    eventType,
                    eventFormat,
                    eventPlatform,
                    eventEntry,
                    eventUscfRated,
                    eventUscfOnlineRated,
                    eventFideRated,
                    eventNormPossible,
                    eventPlatformRated,
                    eventPairingSystem,
                    eventTimeControl,
                    eventSeats,
                    eventRounds,
                    eventPrizeFund,
                    eventServiceLevel,
                    eventDescription,
                    eventDescriptionJSON,
                    eventAddress,
                    eventCity,
                    eventState,
                    eventZipCode,
                    eventTimeZone,
                    eventStartDateTime,
                    eventEndDateTime,
                    eventRegistrationDeadline,
                    eventByeRequestDeadline,
                    eventFlyerUrl,
                    eventRegistrationUrl,
                    eventPairingUrl,
                    eventLiveGameUrl,
                    eventHotelReservationLink,
                    eventFideRegistrationLink,
                    copyEventDelegations,
                    copyDicsountPolicies
                })).unwrap();
                clonedEventId = clonedEvent.eventID;
            } catch (err) {
                console.error('Failed to clone the event: ', err)
            } finally {
                setCloneRequestStatus('idle')
            }
        }
        if (clonedEventId !== '') {
            history.push(`/editEvent/${clonedEventId}`); //https://stackoverflow.com/questions/50925939/react-history-push-not-rendering-new-component
            //history.push(`/events`);
        }
    }

    const onCancelClicked = async () => {
        history.push(`/events/${eventId}`)
        //history.push(`/events/`)
    }
    



    return (
    <div>
        { event &&
        <div>
            <Typography variant="h5" gutterBottom>
                        {'Clone event from : ' + fromEventName}
            </Typography>
            <Box my={2}>
                <Paper my={2} elevation={3} >
                    <Accordion m={2} pt={3} pl={3} pr={3} defaultExpanded={true}>
                            <AccordionSummary aria-controls="event-info" id="event-info" expandIcon={<ExpandMoreIcon />}>
                                    <Typography color={eventStatus == 0 ? 'error' : 'primary'}>Give the event a different name and starting date and time</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container direction="row" rowSpacing={1} columnSpacing={1} justify-content="space-between" align-items="stretch">
                                <Grid item xs={12} lg={6}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>
                                        <InputLabel fullWidth id="event-name-helper-label"></InputLabel>
                                        <TextField
                                            autoFocus={true}
                                            labelId="event-name-helper-label"
                                            required
                                            size="small"
                                            fullWidth
                                            id="event-name"
                                            label='New Event Name'
                                            InputLabelProps={{ shrink: true, }}
                                            value={eventName}
                                            onChange={async (e) => { await setEventName(e.target.value) }}
                                        />
                                    </FormControl>
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>
                                                <InputLabel fullWidth id="eventStartDateTime-helper-label"></InputLabel>
                                                <TextField
                                                    labelId="eventStartDateTime-helper-label"
                                                    required
                                                    size="small"
                                                    fullWidth
                                                    id="eventStartDateTime"
                                                    label='New Start Date and Time'
                                                    type='datetime-local'
                                                    InputLabelProps={{ shrink: true, }}
                                                    value={eventStartDateTime}
                                                    onChange={async (e) => { await setEventStartDateTime(e.target.value) }}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} lg={3}>
                                            <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                                <FormGroup row={true} >
                                                    <FormControlLabel control={<Checkbox checked={copyEventDelegations} size="small" onChange={async (e) => { await setCopyEventDelegations(e.target.checked);} } />} label="Copy Event Delegations" />
                                                </FormGroup>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} lg={3}>
                                            <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                                <FormGroup row={true} >
                                                    <FormControlLabel control={<Checkbox checked={copyDicsountPolicies} size="small" onChange={async (e) => { await setCopyDicsountPolicies(e.target.checked);  } } />} label="Copy Dicsount Policies" />
                                                </FormGroup>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} lg={3}>
                                            <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                                <Button variant="contained" color="error" onClick={onCancelClicked}>Cancel</Button>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} lg={3}>
                                            <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                                <Button variant="contained" disabled={eventName === fromEventName && eventStartDateTime === fromEventStartDateTime} onClick={onCloneEventClicked}>Clone Event</Button>
                                            </FormControl>
                                        </Grid>
                            </Grid>

                        </AccordionDetails>
                    </Accordion>
                </Paper>
            </Box>
            
        </div >
        }
        { !event &&
                <Typography variant="h5" gutterBottom>
                    {'Loading ...'}
                </Typography>
        }
     </div>
    )
}

